import { TagsIcon } from "lucide-react";

import { TagGroupFragment } from "@/__generated__/graphql";
import { ObjectType } from "@/objects/@types";

const object: ObjectType<TagGroupFragment> = {
  humanName: "tag group",
  inputKey: "tagGroup",
  typename: "TagGroupObject",
  ReactIcon: TagsIcon,
  titleFieldKey: "name",
  getTitle: (data) => {
    return data?.name || "";
  },
  getEntityId: () => {
    return null;
  },
  isEntity: false,
  fieldDefinitions: [
    {
      objectKey: "tags",
      label: "Tags",
      type: "tags",
      ReactIcon: TagsIcon,
      asString: (data) => data?.tags?.map((tag) => tag.name).join(", ") || "",
      getValue: (data) => {
        return (data?.tags || []).map((tag) => ({
          __typename: tag.__typename,
          id: tag.id,
          identifier: tag.identifier,
          name: tag.name,
          color: tag.color,
        }));
      },
      getValueOptions: () => null,
      updateProps: {
        isRequired: true,
        isEditable: true,
      },
      summaryProps: {
        isVisible: true,
      },
    },
  ],
};

export { object as TagGroupObject };
